import React from 'react';
import SellerRegistrationFrom from '../SubComponents/SellerRegistrationForm';

function RegisterSeller() {
    return (
      <SellerRegistrationFrom />
    );
  }

export default RegisterSeller;